import LegalPageLayout from './LegalPageLayout';

export default function TermsOfService() {
  return (
    <LegalPageLayout
      title="Términos y Condiciones"
      updatedAt="22 de julio de 2026"
      description="Términos y condiciones de uso de CavernicolApp, la plataforma de CRM, agenda, conversaciones y automatización con IA operada por Dragon Technologies."
    >
      <p>
        Estos Términos y Condiciones ("Términos") regulan el acceso y uso de <strong>CavernicolApp</strong>
        (el "Servicio"), disponible en <a href="https://app.cavernicolapp.com">app.cavernicolapp.com</a> y
        dominios relacionados. Al crear una cuenta, contratar un plan o usar el Servicio de cualquier forma,
        aceptas estos Términos en representación tuya y, en su caso, de la empresa a la que representas
        ("tú" o "el Cliente").
      </p>

      <div className="legal-page__entity-card">
        <h3>¿Quién opera CavernicolApp?</h3>
        <p>
          <strong>Dragon Technologies, S.A.P.I. de C.V.</strong> (RFC DTE220909DT1), con domicilio en Río Nazas 42,
          Despacho 4-B, Colonia Cuauhtémoc, Alcaldía Cuauhtémoc, C.P. 06500, Ciudad de México, México, opera
          CavernicolApp para clientes en México y es la responsable principal frente a ti. Para clientes e
          infraestructura fuera de México, <strong>Dragon Technologies LLC</strong> (EIN 33-2352150), con domicilio
          en 8131 W Hausman Rd Ste 102, San Antonio, TX 78249, Estados Unidos, actúa como corresponsable del
          Servicio (procesamiento de pagos internacionales e infraestructura). Ambas entidades operan bajo la
          marca CavernicolApp / Cavernícola Creativo.
        </p>
      </div>

      <h2>1. Descripción del Servicio</h2>
      <p>
        CavernicolApp es una plataforma de software como servicio (SaaS) que conecta CRM, agenda, conversaciones
        multicanal (WhatsApp, redes sociales, correo, voz), marketing, automatización y agentes de inteligencia
        artificial, adaptable a distintas industrias ("verticales"). El Servicio se ofrece bajo planes de
        suscripción con distintos niveles de funcionalidad, descritos en la plataforma al momento de la
        contratación.
      </p>

      <h2>2. Cuenta y registro</h2>
      <p>
        Debes proporcionar información veraz al registrarte y mantenerla actualizada. Eres responsable de
        mantener la confidencialidad de tus credenciales y de toda actividad realizada bajo tu cuenta. Debes
        notificarnos de inmediato cualquier uso no autorizado sospechado. Nos reservamos el derecho de suspender
        cuentas con información falsa o actividad fraudulenta.
      </p>

      <h2>3. Planes, precios y facturación</h2>
      <p>
        Los precios se muestran en pesos mexicanos (MXN) salvo que se indique otra moneda expresamente. La
        suscripción se renueva automáticamente por el mismo periodo salvo cancelación antes del corte. Los
        cargos por consumo adicional (por ejemplo, uso de IA, mensajería o llamadas por encima de tu plan) se
        facturan conforme a las tarifas vigentes mostradas en la plataforma. No hay reembolsos por periodos ya
        iniciados, salvo que la ley aplicable exija lo contrario.
      </p>

      <h2>4. Uso aceptable</h2>
      <p>Al usar CavernicolApp te comprometes a NO:</p>
      <ul>
        <li>Enviar mensajes masivos no solicitados (spam) o contenido que viole las políticas de WhatsApp Business, Meta, o cualquier proveedor de mensajería/redes integrado.</li>
        <li>Usar el Servicio para actividades ilegales, fraudulentas, difamatorias o que infrinjan derechos de terceros.</li>
        <li>Intentar vulnerar la seguridad de la plataforma, realizar ingeniería inversa, o acceder a datos de otros clientes sin autorización.</li>
        <li>Revender o sublicenciar el Servicio sin autorización expresa por escrito.</li>
        <li>Cargar datos de salud, financieros sensibles o de menores de edad sin el consentimiento y base legal correspondientes.</li>
      </ul>

      <h2>5. Tus datos y los datos de tus clientes</h2>
      <p>
        Tú conservas la titularidad de la información que cargas a la plataforma, incluyendo los datos de tus
        propios clientes y prospectos ("Datos de Terceros"). Para procesar esos Datos de Terceros (por ejemplo,
        conversaciones de WhatsApp, citas o registros de CRM), CavernicolApp actúa como <strong>encargado del
        tratamiento</strong> por instrucción tuya, no como responsable — eres tú quien determina las finalidades
        y debe contar con la base legal correspondiente frente a tus propios clientes. Ver nuestro
        <a href="/privacidad"> Aviso de Privacidad</a> para el tratamiento de tus propios datos como usuario de
        la plataforma.
      </p>

      <h2>6. Integraciones con terceros</h2>
      <p>
        El Servicio permite conectar proveedores externos (Meta/WhatsApp/Instagram/Facebook, Google, Twilio,
        proveedores de IA, pasarelas de pago, entre otros). El uso de esas integraciones también está sujeto a
        los términos y políticas de cada proveedor externo, sobre los cuales no tenemos control directo. No
        somos responsables por interrupciones, cambios de política o suspensión de acceso originados por esos
        terceros.
      </p>

      <h2>7. Propiedad intelectual</h2>
      <p>
        CavernicolApp, su código, marca, diseño y contenido son propiedad de Dragon Technologies y están
        protegidos por las leyes de propiedad intelectual aplicables. Estos Términos no te otorgan ningún
        derecho de propiedad sobre el software, únicamente una licencia de uso limitada, no exclusiva e
        intransferible mientras tu suscripción esté vigente.
      </p>

      <h2>8. Disponibilidad del servicio</h2>
      <p>
        Trabajamos para mantener el Servicio disponible de forma continua, pero no garantizamos operación
        ininterrumpida o libre de errores. Podemos realizar mantenimientos programados o de emergencia,
        notificando cuando sea razonablemente posible.
      </p>

      <h2>9. Limitación de responsabilidad</h2>
      <p>
        En la máxima medida permitida por la ley, Dragon Technologies no será responsable por daños indirectos,
        incidentales, especiales o consecuentes derivados del uso o la imposibilidad de uso del Servicio,
        incluyendo pérdida de datos, ingresos o clientes, aun cuando se nos haya advertido de la posibilidad de
        dichos daños. Nuestra responsabilidad total frente a ti no excederá el monto pagado por el Servicio en
        los tres meses previos al evento que la origine.
      </p>

      <h2>10. Terminación</h2>
      <p>
        Puedes cancelar tu suscripción en cualquier momento desde la plataforma. Podemos suspender o terminar tu
        acceso si incumples estos Términos, incluyendo falta de pago o uso indebido del Servicio. Al terminar,
        podrás solicitar la exportación de tus datos dentro de un plazo razonable antes de su eliminación
        definitiva.
      </p>

      <h2>11. Modificaciones a estos Términos</h2>
      <p>
        Podemos actualizar estos Términos periódicamente. Notificaremos cambios sustanciales por correo o dentro
        de la plataforma. El uso continuado del Servicio después de una actualización constituye tu aceptación
        de los nuevos Términos.
      </p>

      <h2>12. Ley aplicable y jurisdicción</h2>
      <p>
        Estos Términos se rigen por las leyes de los Estados Unidos Mexicanos. Para cualquier controversia
        relacionada con el Servicio, las partes se someten a los tribunales competentes de la Ciudad de México,
        renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o
        futuro.
      </p>

      <h2>13. Contacto</h2>
      <p>
        Dudas sobre estos Términos: <a href="mailto:contacto@cavernicolacreativo.com">contacto@cavernicolacreativo.com</a>.
      </p>

      <p className="legal-page__note">
        Este documento es una plantilla estándar para plataformas SaaS y no sustituye una revisión por un
        abogado especializado en tu jurisdicción — te recomendamos validarlo con asesoría legal antes de
        depender de él para disputas contractuales de alto riesgo.
      </p>
    </LegalPageLayout>
  );
}
